import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import FormField from '@ui/formfield/FormField';
import api from '@utils/api';
import createDecorator from 'final-form-focus';
import React, { useRef, useState } from 'react';
import { Form } from 'react-final-form';
import ReCAPTCHA from 'react-google-recaptcha';
import { useTranslation } from 'react-i18next';
const focusOnError = createDecorator(); // must be outside the component
const RestrictedRegisterForm = (props) => {
    const { t } = useTranslation();
    /*   const [formdef, setFormdef] = useState<models.FormDefinition>();*/
    /*   const [initialValues, setInitialValues] = useState<models.RegisterClothingForm>(); */
    const [errors, setErrors] = useState([]);
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [errorPassword, setErrorPassword] = React.useState(false);
    const [errorCheckbox, setErrorCheckbox] = React.useState(false);
    const registerFormRef = useRef(null);
    const reCaptchaRef = useRef();
    const showRecaptcha = window.recapchaCfg && JSON.parse(window.recapchaCfg).registerButton;
    const subtitlePrefix = window.isEmployeeSales ? 'employeesales' : 'clothing';
    /*   useEffect(() => {
      let val: models.RegisterClothingForm = {} as models.RegisterClothingForm;
      api.getForm('profile', val).then((data) => {
        if (params.get('email')) {
          val.email = params.get('email');
        }
      });
    }, []); */
    const onSubmit = async (values) => {
        setErrors([]);
        if (!values.password) {
            setErrorPassword(true);
            setErrors([t('label.requiredfield')]);
            return;
        }
        else {
            setErrorPassword(false);
        }
        if (values.confirmPassword != values.password) {
            console.log('Error');
            setErrors([t('error.message.mismatch.newpassword')]);
            return;
        }
        if (!values.termconditions) {
            setErrorCheckbox(true);
            setErrors([t('label.requiredfield')]);
            return;
        }
        else {
            setErrorCheckbox(false);
        }
        setIsSubmitting(false);
        values.email = props.loginEmail;
        if (showRecaptcha) {
            const token = await reCaptchaRef.current.executeAsync();
            values.gr3Token = token;
        }
        api
            .registerClothing(values)
            .then((data) => {
            setIsSubmitting(true);
            if (data.error) {
                if (data.error.length > 0) {
                    setErrors(data.error);
                }
                else {
                    setErrors([data.message]);
                }
                setIsSubmitting(false);
            }
            /*    if (!formutils.checkValidationAfterSubmit(data, errors)) {
              return errors;
            } */
            if (data.success) {
                /*           window.location.replace(data.redirectUrl);
                 */
                props.setLoginStep('doubleOptIn');
                props.setFromRegister(true);
            }
        })
            .catch((e) => {
            setErrors([e]);
            setIsSubmitting(false);
        });
    };
    return (React.createElement("div", { className: "register_form" },
        React.createElement("h2", { className: "primary-s form-title" }, t('register.title')),
        React.createElement("div", { className: "mb-40 row clothing-register-subtitle" },
            React.createElement("p", null, t(subtitlePrefix + '.register.subtitle')),
            React.createElement("button", { onClick: () => props.setLoginStep('email'), className: "link" }, t('login.editemail'))),
        React.createElement("div", null,
            React.createElement(Form, { onSubmit: onSubmit, decorators: [focusOnError], render: (formprops) => {
                    return (React.createElement("form", { ref: registerFormRef, onSubmit: (e) => {
                            formprops.handleSubmit(e);
                        } },
                        !window.clickfromstore && (React.createElement(React.Fragment, null,
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 password" },
                                    React.createElement(FormField, { helperText: t('register.passwordcriteria'), name: "password", label: t('label.password'), type: "password", autocomplete: "password", showPassword: true, required: true }),
                                    errorPassword && React.createElement("span", { className: "invalid-feedback" }, errors))),
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-12 password" },
                                    React.createElement(FormField, { name: "confirmPassword", label: t('label.confirmpassword'), type: "password", autocomplete: "password", showPassword: true, required: true }))))),
                        React.createElement("div", { className: "row mb-24" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement("div", { className: "flag" },
                                    React.createElement(FormField, { name: "termconditions", label: t('preferences.privacysettings.termsandconditionsclothing', { 0: props.conditionsofuse, 1: props.privacypolicy }), type: "checkbox", checked: true }),
                                    errorCheckbox && React.createElement("span", { className: "invalid-feedback" }, errors)))),
                        React.createElement("div", { className: "register_form__label" },
                            React.createElement("p", null, t('label.mandatoryfields'))),
                        !errorPassword && !errorCheckbox && React.createElement(ErrorBox, { errors: errors }),
                        showRecaptcha && React.createElement(ReCAPTCHA, { className: "recaptcha", sitekey: window.atob(window.recapchaData), size: "invisible", ref: reCaptchaRef }),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-12" },
                                React.createElement(Button, { type: "submit", disabled: isSubmitting, cls: ['button--primary'] }, t('button.createaccount.registration'))))));
                } }))));
};
export default RestrictedRegisterForm;
